import lowerCase from 'lodash/lowerCase';
import { string } from 'prop-types';
import React from 'react';

function BookingEntryChange({ fieldChanged, valueBefore, valueAfter }) {
  const [, id, field] = fieldChanged.split('.');
  if (field === 'invoice') {
    return (
      <div>
        <b>Booking entry {id}</b> was assigned to &quot;{valueAfter}&quot;.
      </div>
    );
  }
  return (
    <div title={valueBefore ? `Changed from ${valueBefore}` : ''}>
      <b>
        Booking entry {id} - {lowerCase(field)}
      </b>{' '}
      changed to &quot;{valueAfter}&quot;.
    </div>
  );
}

BookingEntryChange.propTypes = {
  fieldChanged: string.isRequired,
  valueAfter: string.isRequired,
  valueBefore: string,
};
BookingEntryChange.defaultProps = {
  valueBefore: '',
};

export default BookingEntryChange;
